export default {"src":"/_next/static/media/white-3D-tour-icon.24bb0811.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};